import { useEffect, useState } from "react";
import getTransferData from "./Helpers/getTransferData";
import { useParams, useNavigate } from "react-router-dom";
import { decrypt } from "../../Utilities/utils";
import { CIS_FORM_CONFIRMATION_PAGE_ROUTE, QUICK_QUOTE_ROUTE } from "../routes";
import { POLICY_STATUS } from "../../PersonalAccident/PaymentOptionsPage/usePaymentOptions.js";
import Swal from "sweetalert2";
import { getLocalData } from "../../Utilities/Common/source";

const useCreateQuotePage = () => {
  const { transferDataId, acuvisorProductId } = useParams();

  const navigate = useNavigate();

  const decryptedTransferDataId = decrypt(
    decodeURIComponent(transferDataId).toString(),
    process.env.REACT_APP_SECRET_KEY
  ).replace(/["]/g, "");

  const decryptedAcuvisorProductId = decrypt(
    decodeURIComponent(acuvisorProductId),
    process.env.REACT_APP_SECRET_KEY
  ).replace(/["]/g, "");

  const [transferData, setTransferData] = useState(null);

  useEffect(() => {
    const localSource = getLocalData("source");
    console.log("OS UseCQP localSource: ", localSource);
    getTransferData(decryptedTransferDataId, localSource).then((response) => {
      setTransferData(response);
      if (response?.policy_status === POLICY_STATUS.CREATE_QUOTE_SUBMISSION) {
        Swal.fire({
          title: "Proposal already generated",
          text: "Proceed to payment or go back to quick quote.",
          icon: "warning",
          confirmButtonColor: "#0d409b",
          cancelButtonColor: "#d33",
          confirmButtonText: "Proceed to Payment",
          cancelButtonText: "Go to Quick Quote",
          showCancelButton: true,
          reverseButtons: true,
        }).then((result) => {
          const stateToPass = {
            source: getLocalData("source"),
          };
          if (result.dismiss === Swal.DismissReason.cancel) {
            navigate(QUICK_QUOTE_ROUTE, { state: stateToPass });
          } else {
            navigate(
              `${CIS_FORM_CONFIRMATION_PAGE_ROUTE}/${encodeURIComponent(
                decryptedTransferDataId
              )}`
            );
          }
        });
      }
    });
  }, [decryptedTransferDataId]);

  return {
    transferData,
    acuvisorProductId: decryptedAcuvisorProductId,
    transferDataId: decryptedTransferDataId,
  };
};

export default useCreateQuotePage;
